// extracted by extract-css-chunks-webpack-plugin
module.exports = {"overlay":"el5_B","text":"_3Dun_","hidden":"_2jI81"};